const numberToString = (param) => {
  return `${param}px`
}

export default numberToString 
	